export default __webpack_public_path__ + "static/media/referral.eeda0043.png";